import clsx from "clsx";

export function Divider({
	soft = false,
	className,
	...props
}: { soft?: boolean } & React.ComponentPropsWithoutRef<"hr">) {
	return (
		<hr
			{...props}
			className={clsx(
				className,
				"w-full border-t",
				soft && "border-base-content/5",
				!soft && "border-base-content/10",
			)}
		/>
	);
}
